export default __webpack_public_path__ + "static/media/midiaBg.f7d13f81.png";